import {useEffect, useState} from 'react';
import {Button, Image, Menu, Typography} from 'antd';
import {useDispatch} from 'react-redux';
import Pikado from '../assets/icons/PikaDoLogo.png';

const {Text} = Typography;

export const SiderComponent = () => {
  const dispatch = useDispatch();
  useEffect(() => {}, []);

  return (
    <div>
      {/* Old header removed - now using DashboardHeader in each page */}
      {/* <img
        className="pikado-image"
        alt="s"
        src={Pikado}
        style={{
          resize: 'inline',
          width: '12%',
          height: '10%',
          alignSelf: 'center',
        }}
      />
      <Text
        style={{
          alignSelf: 'flex-end',
          color: 'white',
          fontWeight: 'bold',
          textAlign: 'left',
          marginInline: 4,
          marginInlineEnd: 20,
        }}>
        Schools
      </Text>
      <RenderTabs />
      <Menu.Item style={{}} key="signOut">
        <Button
          style={{width: 150, fontWeight: 'bold'}}
          onClick={async () => {
            await Auth.signOut();
            dispatch({type: 'RESET_USER'});
            history.go(0);
          }}>
          Logout
        </Button>
      </Menu.Item> */}
    </div>
  );
};
